<app-item-content [instructionItemContentTemplate]="itemContentBoxes" [row]="row" [startLabel]="startLabel" [endLabel]="endLabel"></app-item-content>
<ng-template #itemContentBoxes let-index="index" let-instruction="instruction" let-overlaps="scheduledAndOverlapsSelectedDate">
	@if (overlaps && instruction.physioLevel !== null) {
		<app-instruction-box>{{ physioLevel[index] }}</app-instruction-box>
	}
</ng-template>